import { Button, ButtonProps, Menu } from '@mantine/core';
import { IconCirclePlus, IconUserPlus, IconUsers } from '@tabler/icons-react';
import { useClientsContext } from '../../clients/context/ClientsContext';
import CreateClientModal from '../../clients/CreateClientModal';
import CreateClientModalV2 from '../../clients/CreateClientModalV2';
import CreateFamilyFlow from '../../clients/CreateFamily/CreateFamilyFlow';
import EditFamilyFlow from '../../clients/CreateFamily/EditFamilyFlow';
import useCurrentUser from 'src/admin/users/hooks/useCurrentUser';
import { useUsersContext } from 'src/admin/users/context/UsersContext';
import CreateUserModal from 'src/admin/users/components/CreateUserModal';
import { useIsAfternoon } from 'src/common/useIsAfternoonHook';
import { useFlags } from 'src/feature-flags/FlagsHook';
import { useNavigate } from 'react-router';

export function CreateButton({ buttonProps }: { buttonProps?: ButtonProps }) {
  const { isSystemAdmin } = useCurrentUser();
  const { flow, clientPrefill, startClientCreation, startFamilyCreation, close } =
    useClientsContext();
  const { flow: usersFlow, close: usersClose } = useUsersContext();
  const { isAfternoonAdmin } = useIsAfternoon();
  const { flagEnabledFamilyFlowFrontend } = useFlags();
  const navigate = useNavigate();

  return (
    <>
      <Menu shadow="md" width={200}>
        <Menu.Target>
          <Button variant="primary" leftSection={<IconCirclePlus size={20} />} {...buttonProps}>
            Create new
          </Button>
        </Menu.Target>

        <Menu.Dropdown>
          <Menu.Item leftSection={<IconUserPlus size={16} />} onClick={() => startClientCreation()}>
            Client
          </Menu.Item>

          <Menu.Item
            leftSection={<IconUsers size={16} />}
            onClick={
              flagEnabledFamilyFlowFrontend
                ? () => navigate('/clients/families/new')
                : startFamilyCreation
            }
          >
            Family
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>

      {flagEnabledFamilyFlowFrontend ? (
        <CreateClientModalV2 opened={flow === 'client'} close={close} prefill={clientPrefill} />
      ) : (
        <CreateClientModal opened={flow === 'client'} close={close} prefill={clientPrefill} />
      )}

      {isSystemAdmin && (
        <CreateUserModal
          opened={usersFlow === 'create-user'}
          close={usersClose}
          showSecretMenuAccessOption={!!isAfternoonAdmin}
        />
      )}

      <CreateFamilyFlow />

      <EditFamilyFlow />
    </>
  );
}
